<template>
  <section class="usercenter">
    <div class="usercenterback">
      <div class="userhead">
        <img :src="WxHeadImg" />
      </div>
      <div class="usermain">
        <van-cell-group>
          <van-cell title="用户名" :value="UserName" />
          <!-- <van-cell title="手机号" :value="MoblieNo" /> -->
        </van-cell-group>
      </div>
      <van-button class="loginout" @click="OnLoginOutClick" block
        >退出登陆</van-button
      >
    </div>
  </section>
</template>
<script>
import { jsencrypt } from "@/modules/js/des";
import { BzAjax, BzJs, BzUser, BzMsg } from "@/modules/js/helper";
const md5 = require("md5");
export default {
  data() {
    return {
      MoblieNo: "",
      UserName: "",
      WxHeadImg: "",
    };
  },
  created() {
    var user = BzUser.get();
    if (user.IsLogin == 0) {
      this.$router.push("/");
    }
    // this.MoblieNo = user.MoblieNo;
    this.UserName = user.UserName;
    this.WxHeadImg =
      "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png";
  },
  methods: {
    OnLoginOutClick() {
      BzUser.deleteuser();
      this.$router.push("/");
    },
  },
};
</script>
<style lang="less">
.usercenter {
  .usercenterback {
    height: calc(100vh - 46px);
    background-color: #ebeef5;
    width: 100vw;
    display: flex;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    .userhead {
      background: url("../../modules/assets/usercenter.jpg") no-repeat;
      background-size: 100% 100%;
      width: 100%;
      text-align: center;
      height: 8.59rem;
      img {
        margin-top: 1.51rem;
        width: 5.33rem;
        height: 5.33rem;
        border-radius: 50%;
      }
    }
    .usermain {
      padding-bottom: 2.5rem;
      background-color: white;
    }
    .loginout {
      margin-top: 1.06rem;
      color: red;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/usercenter.vue